export default __webpack_public_path__ + "static/media/jsm_cover.86d783fd.jpg";